import React from 'react';
import getGlyph from './glyphs';
function Icon({ glyph, size = '24', stroke = 'currentColor', strokeWidth = '2', ...otherProps }) {
  const Glyph = getGlyph(glyph);

  if (Glyph) {
    return <Glyph {...otherProps} size={size} stroke={stroke} strokeWidth={strokeWidth} />;
  }

  return null;
}

export default Icon;
